/**
 * PORTED — RO-11-05 / #44590.
 * Origin: `excellent/app/_chrome/rail-chrome.tsx`.
 *
 * The Next original is an async SERVER component that calls loadRailScope().
 * On the Vite host that data is not available yet as a dedicated endpoint field
 * (GET /api/shell is RO-11-01; workspace catalog may land there later). Until
 * then this is a CLIENT wrapper that takes workspaces as props — RootShell
 * passes empty defaults so the switcher stays hidden when unauthenticated /
 * unseeded (same visual as the login-gated empty path on Next).
 */

import {
  RailChromeClient,
  type WorkspaceOption,
} from "./rail-chrome-client";

/**
 * Top of the left navigation rail: workspace switcher. Rendered by RootShell
 * and passed into LeftRail → SectionRail as `topSlot`.
 */
export function RailChrome({
  workspaces = [],
  activeWorkspaceId = null,
}: {
  workspaces?: WorkspaceOption[];
  activeWorkspaceId?: number | null;
} = {}) {
  return (
    <RailChromeClient
      workspaces={workspaces}
      activeWorkspaceId={activeWorkspaceId}
    />
  );
}
